import { render, staticRenderFns } from "./OfficialHolidaysPlanForm.vue?vue&type=template&id=790ba3ee&scoped=true&"
import script from "./OfficialHolidaysPlanForm.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ba3ee",
  null
  
)

export default component.exports